import axiosInstance from "config/axiosConfig";

const API_URL = "/note";

interface fetchLoginHistoryInterface {
  startTimestamp?: string;
  endTimestamp?: string;
  userId?: string;
}

export const fetchLoginHistory = async ({
  startTimestamp,
  endTimestamp,
  userId,
}: fetchLoginHistoryInterface) => {
  try {
    const response = await axiosInstance.get("/event", {
      params: {
        startTimestamp,
        endTimestamp,
        userId,
        // eventType: "USER_LOGIN",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching login history:", error);
    throw error;
  }
};

export const fetchAllLoginHistory = async () => {
  try {
    const response = await axiosInstance.get("/event", {
      params: {
        eventType: "USER_LOGIN",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching login history:", error);
    throw error;
  }
};
